<template>
  <span
    class="inline-flex items-center justify-center gap-1.5 rounded-full border text-xs font-medium px-2.5 py-0.5"
    :class="statusMeta.color"
    v-bind="$attrs"
  >
    <i :class="statusMeta.icon" class="text-[10px]"></i>
    {{ statusMeta.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ShopifyPayoutStatus } from '@/types/shopifyPayouts'

interface StatusMeta {
  label: string
  icon: string
  color: string
}

const STATUS_CONFIG: Record<ShopifyPayoutStatus, StatusMeta> = {
  PAID: {
    label: 'Paid',
    icon: 'pi pi-check-circle',
    color:
      'bg-green-50 text-green-700 border-green-200 dark:bg-green-900/20 dark:text-green-200 dark:border-green-700',
  },
  IN_TRANSIT: {
    label: 'In Transit',
    icon: 'pi pi-truck',
    color:
      'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/20 dark:text-blue-200 dark:border-blue-700',
  },
  SCHEDULED: {
    label: 'Scheduled',
    icon: 'pi pi-clock',
    color:
      'bg-surface-50 text-surface-700 border-surface-200 dark:bg-surface-800 dark:text-surface-200 dark:border-surface-700',
  },
  FAILED: {
    label: 'Failed',
    icon: 'pi pi-times-circle',
    color:
      'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-200 dark:border-red-700',
  },
  CANCELED: {
    label: 'Canceled',
    icon: 'pi pi-ban',
    color:
      'bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-900/20 dark:text-orange-200 dark:border-orange-700',
  },
}

const props = defineProps<{
  status: ShopifyPayoutStatus
}>()

const statusMeta = computed(
  () => STATUS_CONFIG[props.status] || STATUS_CONFIG.SCHEDULED,
)
</script>
